import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*(id, name, internalId, enabled) {
  return yield oncallFetch("/api/oncall/administration/partners/update", {
    id,
    name,
    internalId,
    enabled,
  });
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/administration/partners/update.js